import { render, staticRenderFns } from "./CfgSistemasIntegração.vue?vue&type=template&id=0cf793ca"
import script from "./CfgSistemasIntegração.vue?vue&type=script&lang=js"
export * from "./CfgSistemasIntegração.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports